const boldWords = (word, boldWords, pn) => {
  if (!boldWords) {
    return { __html: word };
  }

  let singleBold = [...new Set(boldWords.map(w => w.split(" ")))].reduce(
    (acc, val) => acc.concat(val),
    []
  );

  let splitedWord = word.trim();
  // this case is for the part numbers

  singleBold.forEach(bw => {
    bw = bw.replace("*", "");
    bw = bw.trim();
    const start = splitedWord.toLowerCase().search(bw.toLowerCase());
    if (start !== -1 && splitedWord[start - 1] !== "<") {
      let firstPart = splitedWord.substring(0, start);
      let mid = splitedWord.substring(start, start + bw.length);
      let endPart = splitedWord.substring(mid.length + start);

      splitedWord = firstPart + mid.bold() + endPart;
    }
  });

  return {
    __html: splitedWord
  };
};

export default boldWords;
